<template>
    <div>
        site visit log tab
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>